// extracted by mini-css-extract-plugin
module.exports = {"batchFieldContainer":"BatchFieldStyles_batchFieldContainer__3S50c","batchInfoIcon":"BatchFieldStyles_batchInfoIcon__3aona"};